import React, { useState, useEffect } from 'react'
import Helmet from '../components/helmet/Helmet'
import { Container, Row, Col } from 'reactstrap'
import { motion } from 'framer-motion'
import Services from '../services/Services'
import Clock from '../components/ui/Clock'
import { Link } from 'react-router-dom'
import ProductsList from '../components/ui/ProductsList'
import products from '../assets/data/products'
import counter from '../assets/images/counter-timer-img.png'

import '../style/home.css'
const Home = () => {
  const [trendingProducts, setTrendingProducts] = useState([])
  const [salesPtoducts, setSalesProducts] = useState([])
  const [mobileProducts, setMobileProducts] = useState([])
  const [wirelessProducts, setWirelessProducts] = useState([])
  const [popularProducts, setPopularProducts] = useState([])
  const [cosmeticsProducts, setCosmeticsProducts] = useState([])

  const year = new Date().getFullYear()

  useEffect(() => {
    const filteredTrendingProducts = products.filter(
      (item) => item.category === 'chair',
    )
    const filteredSalesProducts = products.filter(
      (item) => item.category === 'sofa',
    )

    const filteredMobileProducts = products.filter(
      (item) => item.category === 'mobile',
    )

    const filteredWirelessProducts = products.filter(
      (item) => item.category === 'wireless',
    )

    const filteredPopularProducts = products.filter(
      (item) => item.category === 'watch',
    )
    const filteredCosmeticsProducts = products.filter(
      (item) => item.category === 'Cosmetics',
    )

    setSalesProducts(filteredSalesProducts)
    setTrendingProducts(filteredTrendingProducts)
    setMobileProducts(filteredMobileProducts)
    setWirelessProducts(filteredWirelessProducts)
    setPopularProducts(filteredPopularProducts)
    setCosmeticsProducts(filteredCosmeticsProducts)
  }, [])
  return (
    <>
      <Helmet title={'Home'}>
        {/* Hero  */}
        <section className="hero__section">
          <Container>
            <Row>
              <Col lg="6" md="6">
                <div className="hero__content">
                  <p className="hero__subtitle">Trending product in {year}</p>
                  <h2>Make Your Interior More Minimalistic & Modern</h2>
                  <motion.button whileTap={{ scale: 1.3 }} className="buy__btn">
                    <Link to="/shop">Shop Now</Link>
                  </motion.button>
                </div>
              </Col>
              <Col lg="6" md="6">
                <div className="hero__img">
                  <iframe
                    title="AR"
                    src="https://shopping.qurashi.xyz/"
                    style={{
                      width: '100%',
                      height: '100%',
                      // borderRadius: "90px",
                      border: 'none',
                      background: 'transparent',
                    }}
                  ></iframe>
                  {/* <img src={HeroImage} alt="" /> */}
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <Services />
        {/* Trending */}
        <section className="trending__products">
          <Container>
            <Row>
              <Col lg="12" className="text-center">
                <h2 className="section__title">Trending Products</h2>
              </Col>
              <ProductsList data={trendingProducts} />
            </Row>
          </Container>
        </section>
        {/* Best Sales */}
        <section className="best__sales">
          <Container>
            <Row>
              <Col lg="12" className="text-center">
                <h2 className="section__title">Best Sales</h2>
              </Col>

              <ProductsList data={salesPtoducts} />
            </Row>
          </Container>
        </section>
        {/* Timer Count */}
        <section className="timer__count">
          <Container>
            <Row>
              <Col lg="6" md="6">
                <div className="clock__top-content">
                  <h4 className="text-white fs-6">Limited Offers</h4>
                  <h3 className="text-white fs-6">Quality Armchair</h3>
                </div>
                <Clock />
                <motion.button
                  whileTap={{ scale: 1.2 }}
                  className="buy__btn store__btn "
                >
                  <Link to="/shop">Visit Store</Link>
                </motion.button>
              </Col>
              <Col lg="6" md="6" className="text-end Timg">
                <img src={counter} alt="" />
              </Col>
            </Row>
          </Container>
        </section>
        {/* New Arrivals */}
        <section className="new__arrivals mb-5">
          <Container>
            <Row>
              <Col lg="12" className="text-center">
                <h2 className="section__title">New Arrivals</h2>
              </Col>
              <ProductsList data={mobileProducts} />
              <ProductsList data={wirelessProducts} />
            </Row>
          </Container>
        </section>
        {/* C */}
        <section className="new__arrivals mb-5">
          <Container>
            <Row>
              <Col lg="12" className="text-center">
                <h2 className="section__title mb-5">New Cosmetics</h2>
              </Col>
              <ProductsList data={cosmeticsProducts} />
              <ProductsList data={wirelessProducts} />
            </Row>
          </Container>
        </section>
        {/* Popular */}
        <section className="popular__category mb-5">
          <Container>
            <Row>
              <Col lg="12" className="text-center mb-5">
                <h2 className="section__title">Popular in Category</h2>
              </Col>
              <ProductsList data={popularProducts} />
            </Row>
          </Container>
        </section>
      </Helmet>
    </>
  )
}

export default Home
